// extracted by mini-css-extract-plugin
module.exports = {"sidebarContainer":"Sidebar_sidebarContainer__1uGzK","Footer":"Sidebar_Footer__3MFJb"};